import { CryptoStocksOptions } from "@/constants/CryptoStocksOptions"
import { useCryptoStocks } from "@usher/pe-client-front-end-lib"
import { CategoryScale, Chart as ChartJS, Filler, Legend, LinearScale, LineElement, PointElement, Title, Tooltip } from "chart.js"
import { useRef } from "react"
import { Line } from "react-chartjs-2"
import { ChartJSOrUndefined } from "react-chartjs-2/dist/types"
import { CurrencyChartSelectors } from "./CurrencyChartSelectors"
const defaultCrypto = "BTC"
const TIME_FRAMES = ["hour", "day", "week", "month", "year"]
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Filler)
export const CryptoStocks = () => {
  const canvasRef = useRef<ChartJSOrUndefined<"line", number[], string> | null>(null)
  const { typeId, setTypeId, setCryptoSymbol, fiatSymbol, setFiatSymbol, chart, rate } = useCryptoStocks({ defaultCrypto, defaultFiat: "EUR" })

  return (
    <div className="chart-changed mb-xs w-full">
      <div className="box box-light">
        <CurrencyChartSelectors
          rate={rate}
          fiatSymbol={fiatSymbol}
          cryptoSymbol={defaultCrypto}
          onChangeCrypto={setCryptoSymbol}
          onChangeFiat={setFiatSymbol}
        />
        <div className="overflow-hidden">
          <div className="max-h-44">
            <Line
              //@ts-ignore
              options={CryptoStocksOptions}
              width={650}
              height={200}
              data={{
                labels: chart.labels,
                datasets: [
                  {
                    pointRadius: 3,
                    pointBackgroundColor: "#68c0ff",
                    tension: 0.3,
                    backgroundColor: "rgba(52,121,194,0.18)",
                    borderColor: "#68c0ff",
                    borderWidth: 2,
                    data: chart.data,
                    fill: true,
                  },
                ],
              }}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
